<template>
	<div class="alerts">
		<v-alert
			v-for="(alert, index) in list"
			:key="index"
			border="top"
			dismissible
			:dark="!alert.textColor || alert.textColor === 'white'"
			:color="alert.type"
			elevation="4"
			class="my-4"
			:value="alert.show"
			:class="`text--${alert.textColor || 'white'}`"
			:icon="alert.largeIcon ? false : getIcon(alert)"
		>
			<div class="d-flex align-center">
				<v-icon
					v-if="alert.largeIcon"
					size="48"
					class="mr-4"
					:color="alert.textColor || 'white'"
				>
					{{ getIcon(alert) }}
				</v-icon>

				<div>
					<div v-if="typeof alert.message === 'object'">
						<div class="alert-title font-weight-bold">
							{{ alert.message.title }}
						</div>
						<div class="alert-description">
							<span
								v-for="(part, idx) in getDescriptionParts(alert)"
								:key="idx"
							>
								<template v-if="typeof part === 'string'">
									{{ part }}
								</template>
								<template v-else>
									<router-link
										:to="part.to"
										class="alert-link"
									>
										{{ part.text }}
									</router-link>
								</template>
							</span>
						</div>
					</div>
					<div v-else>
						{{ alert.message }}
					</div>
					<span v-if="responseMessage(alert.response)">
						– {{ alert.response.data.message }}
					</span>
				</div>
			</div>
		</v-alert>
	</div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
	name: "Alerts",

	computed: {
		...mapFields("alerts", ["list"])
	},

	methods: {
		getIcon(alert) {
			if (alert.icon) return alert.icon;

			switch (alert.type) {
				case "error":
					return "mdi-alert-octagon";

				case "warning":
					return "mdi-alert";

				default:
					return "mdi-alert-circle";
			}
		},

		responseMessage(response) {
			return response?.data?.message;
		},

		getTitle(alert) {
			if (alert.message && typeof alert.message === "object") {
				return alert.message.title;
			}
			return "";
		},

		getDescription(alert) {
			if (alert.message && typeof alert.message === "object") {
				return alert.message.description;
			}
			return "";
		},

		/**
			* Returns array of parts for description: strings or link objects
			* alert.message.description can be:
			* - string
			* - array of { text: string } and/or { text: string, to: route }
			*/
		getDescriptionParts(alert) {
			const desc = alert.message.description;

			if (typeof desc === "string") {
				return [desc];
			}
			if (Array.isArray(desc)) {
				return desc;
			}
			if (desc && typeof desc === "object") {
				// single link or text
				if (desc.to) {
					return [desc];
				}
				return [desc.text || ""];
			}
			return [];
		}
	}
};
</script>

<style scoped lang="scss">
	.alerts {
		position: fixed;
		width: 50%;
		left: 52%;
		margin-left: -25%;
		z-index: 1000;
	}

	.alerts ::v-deep .v-alert {
		width: 90%;
	}

	@media (max-width: 599px) {
		.alerts {
			width: 100%;
			left: 0;
			margin-left: 0;
		}

		.alerts ::v-deep .v-alert {
			width: 100%;
		}
	}
</style>
